import { useLocation } from '@remix-run/react';
import { useEffect } from 'react';

declare global {
  interface Window {
    twq: any;
  }
}

interface PixelProps {
  pixelId: string;
  marketingCookies: boolean;
}

const TwitterPixel = ({ pixelId, marketingCookies }: PixelProps) => {
  const location = useLocation();

  // Fire page view on eaxch route change
  useEffect(() => {
    try {
      if (window.twq) {
        window.twq('track', 'PageView');
      }
    } catch {
      /*swallow exception*/
    }
  }, [location]);

  useEffect(() => {
    try {
      // match valid pixel id: 5+ lowercase alphanumeric chars
      if (pixelId?.match(/^[a-z0-9]{5,}$/) && marketingCookies) {
        const script = document.createElement('script');
        script.id = 'twitter-pixel';
        script.async = true;
        script.innerHTML = `
      (function(){try{
        !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
        },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
        a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
        // Insert Twitter Pixel ID and Standard Event data below
        twq('init','${pixelId}');
      }catch{/*swallow exception*/}})();
            `;
        document.head.appendChild(script);
      }
    } catch {
      /*swallow exception*/
    }
  }, [pixelId, marketingCookies]);

  return null;
};

export default TwitterPixel;
